import { Component, OnInit } from '@angular/core';
import { Code } from './../../code/button';

@Component({
    templateUrl: './button.component.html'
})

export class ButtonComponent implements OnInit {

	code = Code;
	parameters: any[];
	headers: any[];
	Properties: any[];
	styleName: any[];
	styleValue: any[];
  constructor() {
  	
  }

  ngOnInit() {
  	this.parameters = [
        {name: "label",type: "string",default: "null",des: "按钮的文字显示"},
        {name: "icon",type: "string",default: "null",des: "图标名字"},
        {name: "iconPos",type: "string",default: "left",des: "图标的位置,左边和右边"},
        {name: "cornerStyleClass",type: "string",default: "ui-corner-all",des: "定义按钮的圆角,可以用top、left、right替换,例如使用 ui-corner-top 改变按钮上边圆角"},
    ];
    this.Properties = [
    	{name: "type",type: "string",default: "button",des: "按钮的文字显示"},
    	{name: "label",type: "string",default: "null",des: "按钮的文字显示"},
        {name: "icon",type: "string",default: "null",des: "图标名字"},
        {name: "iconPos",type: "string",default: "left",des: "图标的位置,左边和右边"},
        {name: "disabled",type: "boolean",default: "false",des: "使用该属性时,这个组件将被禁用"},
        {name: "style",type: "string",default: "null",des: "元素行内样式"},
        {name: "styleClass",type: "string",default: "null",des: "元素class样式"},
        {name: "onClick",type: "event",default: "null",des: "当按钮被点击时调用该函数"},
        {name: "onFocus",type: "event",default: "null",des: "当该按钮有焦点的时候，调用该函数"},
        {name: "onBlur",type: "event",default: "null",des: "当按钮失去焦点的时候调用该函数"}
    ]
    this.headers = [
        {name : "名字"},
        {name : "类型"},
        {name : "默认"},
        {name : "描述"}
    ];
  }

  handleClick(event) {
    alert("点击事件");
  }

}


// WEBPACK FOOTER //
// ./src/app/view/button/button.component.ts